import dayjs from 'dayjs'
import { z } from 'zod'

export const HolidayCreateSchema = z.object({
  date: z.date().transform((v) => dayjs(v).format('YYYY-MM-DD')),
  description: z.string(),
})

export type HolidayCreateModel = z.infer<typeof HolidayCreateSchema>

export const HolidayUpdateSchema = z.object({
  id: z.number(),
  date: z.date().transform((v) => dayjs(v).format('YYYY-MM-DD')),
  description: z.string(),
})

export type HolidayUpdateModel = z.input<typeof HolidayUpdateSchema>
